export default __webpack_public_path__ + "static/media/Intersemibold.f8f366d5.ttf";